import { setEditTransmitterDialog } from '../reducers/edit_transmitter_dialog';
import { showDialog } from '../reducers/app';
export function editTransmitter(id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        const device = definitions.devices[id];
        if (device && device.transmitter_kind !== undefined) {
            const proto = device.protocol;
            if (proto.name == 'nexa transmitter') {
                dispatch(setEditTransmitterDialog({
                    id: device.id,
                    kind: device.transmitter_kind,
                    title: device.title,
                    comment: device.comment,
                    code: proto.code.toString(),
                    unit: proto.unit.toString(),
                }));
                dispatch(showDialog('transmitter-edit'));
            }
            if (proto.name == 'hasta transmitter') {
                dispatch(setEditTransmitterDialog({
                    id: device.id,
                    kind: device.transmitter_kind,
                    title: device.title,
                    comment: device.comment,
                    code: proto.code.toString(),
                    unit: proto.unit.toString(),
                }));
                dispatch(showDialog('transmitter-edit'));
            }
        }
    };
}
